(function (window) {
  'use strict';

  var PROPERTY_NAME = 'Your Name';
  var PROPERTY_STYLE = 'Style';

  function parseConfig(container) {
    var script = container.querySelector('[data-personalization-config]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function formatMoney(cents, config) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function' && config.moneyFormat) {
      return Shopify.formatMoney(cents, config.moneyFormat);
    }

    if (config && config.moneyFormat) {
      var amount = (cents / 100).toFixed(0);
      var withDecimals = (cents / 100).toFixed(2);
      return config.moneyFormat
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amount)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDecimals)
        .replace(/\{\{\s*amount\s*\}\}/, withDecimals);
    }

    return 'Rs. ' + Math.round(cents / 100);
  }

  function populateSwatches(container, styles) {
    var root =
      container.querySelector('[data-swatches-root]') ||
      container.querySelector('.debaans-personalization__swatches');

    if (!root || !styles.length) return;

    if (root.getAttribute('data-populated') === 'true') return;

    root.innerHTML = '';

    styles.forEach(function (style) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'debaans-personalization__swatch';
      button.setAttribute('data-style-id', style.id);
      button.setAttribute('title', style.label);
      button.setAttribute('aria-label', style.label);

      if (style.image) {
        var image = document.createElement('img');
        image.src = style.image;
        image.alt = style.label;
        image.loading = 'lazy';
        image.width = 72;
        image.height = 72;
        button.appendChild(image);
      } else {
        var label = document.createElement('span');
        label.className = 'debaans-personalization__swatch-label';
        label.textContent = style.label;
        button.appendChild(label);
      }

      root.appendChild(button);
    });

    root.setAttribute('data-populated', 'true');
  }

  function createWidget(container, config) {
    config = config || parseConfig(container) || {};
    var styles = config.styles || [];
    var addonPrice = config.addonPrice || 20000;
    var prefix = container.getAttribute('data-prefix') || '';

    populateSwatches(container, styles);

    var state = {
      enabled: false,
      selectedStyle: null,
      name: ''
    };

    var toggle = container.querySelector('.debaans-personalization__toggle');
    var stylesWrap = container.querySelector('.debaans-personalization__styles');
    var nameWrap = container.querySelector('.debaans-personalization__name-wrap');
    var nameInput = container.querySelector('.debaans-personalization__input');
    var charCount = container.querySelector('.debaans-personalization__char-count');
    var priceNote = container.querySelector('.debaans-personalization__price-note');
    var swatches = container.querySelectorAll('.debaans-personalization__swatch');
    var hiddenName = container.querySelector('[data-property-name]');
    var hiddenStyle = container.querySelector('[data-property-style]');

    function setEnabled(enabled) {
      state.enabled = enabled;
      container.classList.toggle('is-enabled', enabled);

      if (!enabled) {
        state.selectedStyle = null;
        state.name = '';
        container.classList.remove('has-style');
        swatches.forEach(function (swatch) {
          swatch.classList.remove('is-selected');
        });
        if (nameInput) nameInput.value = '';
        updateCharCount();
      } else if (!state.selectedStyle && styles.length) {
        setStyle(styles[0]);
      }

      syncHiddenFields();
    }

    function setStyle(style) {
      state.selectedStyle = style;
      container.classList.add('has-style');
      swatches.forEach(function (swatch) {
        swatch.classList.toggle('is-selected', swatch.getAttribute('data-style-id') === style.id);
      });

      if (nameInput) {
        nameInput.maxLength = style.maxChars || 10;
        nameInput.placeholder = style.placeholder || 'Enter name or initials';
        var label = container.querySelector('[data-name-label]');
        if (label) {
          label.textContent =
            'Name on towel [Maximum ' + (style.maxChars || 10) + ' characters]';
        }
      }

      updateCharCount();
      syncHiddenFields();
    }

    function updateCharCount() {
      if (!charCount || !nameInput) return;
      var max = nameInput.maxLength || 10;
      charCount.textContent = nameInput.value.length + '/' + max + ' characters';
    }

    function syncHiddenFields() {
      if (hiddenName) {
        hiddenName.value =
          state.enabled && state.selectedStyle && state.name ? state.name : '';
        hiddenName.disabled = !(state.enabled && state.selectedStyle);
      }

      if (hiddenStyle) {
        hiddenStyle.value =
          state.enabled && state.selectedStyle ? state.selectedStyle.label : '';
        hiddenStyle.disabled = !(state.enabled && state.selectedStyle);
      }
    }

    if (toggle) {
      toggle.addEventListener('change', function () {
        setEnabled(toggle.value === 'yes');
      });
      setEnabled(toggle.value === 'yes');
    } else {
      setEnabled(true);
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        if (!state.enabled) return;

        var styleId = swatch.getAttribute('data-style-id');
        var style = styles.find(function (item) {
          return item.id === styleId;
        });

        if (!style) return;
        setStyle(style);
        if (nameInput) nameInput.focus();
      });
    });

    if (nameInput) {
      nameInput.addEventListener('input', function () {
        state.name = nameInput.value.trim();
        updateCharCount();
        syncHiddenFields();
      });
    }

    if (priceNote) {
      priceNote.innerHTML =
        'Selections will add <strong>' +
        formatMoney(addonPrice, config) +
        '</strong> to the price';
    }

    var styleLabel = container.querySelector('.debaans-personalization__style-label');
    if (styleLabel) {
      styleLabel.textContent = 'Style (+ ' + formatMoney(addonPrice, config) + ')';
    }

    function getValues() {
      return {
        enabled: state.enabled,
        style: state.selectedStyle,
        name: nameInput ? nameInput.value.trim() : '',
        styleLabel: state.selectedStyle ? state.selectedStyle.label : '',
        propertyName: PROPERTY_NAME,
        propertyStyle: PROPERTY_STYLE
      };
    }

    function validate(itemIndex) {
      var values = getValues();
      var itemLabel = itemIndex ? ' for item #' + itemIndex : '';

      if (!values.enabled) return true;

      if (!values.style) {
        alert('Please select an embroidery style' + itemLabel + '.');
        return false;
      }

      if (!values.name) {
        alert('Please enter the name or initials' + itemLabel + '.');
        return false;
      }

      return true;
    }

    function restore(values) {
      if (!values) return;

      if (toggle && typeof values.enabled === 'boolean') {
        toggle.value = values.enabled ? 'yes' : 'no';
        setEnabled(values.enabled);
      }

      if (values.styleId) {
        var style = styles.find(function (item) {
          return item.id === values.styleId;
        });
        if (style) setStyle(style);
      }

      if (nameInput && values.name) {
        nameInput.value = values.name;
        state.name = values.name;
        updateCharCount();
        syncHiddenFields();
      }
    }

    return {
      getValues: getValues,
      validate: validate,
      restore: restore,
      syncHiddenFields: syncHiddenFields
    };
  }

  function getAddonConfig() {
    var script = document.getElementById('debaans-omg-personalization-config');
    if (!script) {
      script = document.querySelector('[data-personalization-config]');
    }
    if (!script) return { addonVariantIds: [] };

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return { addonVariantIds: [] };
    }
  }

  function isAddonVariant(variantId, config) {
    config = config || getAddonConfig();
    var ids = config.addonVariantIds || [];
    return ids.indexOf(Number(variantId)) !== -1;
  }

  function addPersonalizationAddons(entries) {
    var items = (entries || [])
      .filter(function (entry) {
        return entry.enabled && entry.addonVariantId && entry.name;
      })
      .map(function (entry) {
        var properties = {};
        properties[PROPERTY_NAME] = entry.name;
        return {
          id: entry.addonVariantId,
          quantity: 1,
          properties: properties
        };
      });

    if (!items.length) {
      return Promise.resolve(null);
    }

    return fetch('/cart/add.js?pareto_callback=true', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.json();
    });
  }

  var pendingStandardAddon = null;
  var isAddingStandardAddon = false;

  function refreshMiniCart() {
    if (window.theme && window.theme.miniCart) {
      window.theme.miniCart.updateElements();
      window.theme.miniCart.generateCart();
    }
  }

  function finishStandardAddon() {
    if (!pendingStandardAddon || isAddingStandardAddon) {
      return Promise.resolve();
    }

    var addon = pendingStandardAddon;
    pendingStandardAddon = null;
    isAddingStandardAddon = true;

    return addPersonalizationAddons([addon])
      .then(function () {
        refreshMiniCart();
      })
      .finally(function () {
        isAddingStandardAddon = false;
      });
  }

  function patchAjaxCart() {
    if (!window.AjaxCart || window.AjaxCart.prototype._debaansPersonalizationPatched) {
      return;
    }

    var originalSuccess = window.AjaxCart.prototype.success;

    window.AjaxCart.prototype.success = function (item) {
      var self = this;

      finishStandardAddon()
        .catch(function () {
          return null;
        })
        .then(function () {
          originalSuccess.call(self, item);
        });
    };

    window.AjaxCart.prototype._debaansPersonalizationPatched = true;
  }

  function bindFormValidation() {
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.matches || !form.matches('form.product-form, form[action*="/cart/add"]')) {
          return;
        }

        if (form.closest('.omg-offer, .otTableOffer')) return;

        var widgets = form.querySelectorAll('[data-debaans-personalization]');
        if (!widgets.length) return;

        for (var i = 0; i < widgets.length; i++) {
          var widget = widgets[i].__debaansPersonalization;
          if (widget && !widget.validate()) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            return;
          }
        }

        var widget = widgets[0].__debaansPersonalization;
        var values = widget ? widget.getValues() : null;
        pendingStandardAddon =
          values && values.enabled && values.style && values.style.addonVariantId
            ? {
                enabled: true,
                addonVariantId: values.style.addonVariantId,
                name: values.name
              }
            : null;
      },
      true
    );

    patchAjaxCart();
    window.setTimeout(patchAjaxCart, 0);
    document.addEventListener('shopify:section:load', patchAjaxCart);
  }

  function mountAll(root) {
    var scope = root || document;
    var widgets = [];

    scope.querySelectorAll('[data-debaans-personalization]').forEach(function (container) {
      if (container.__debaansPersonalization) return;
      container.__debaansPersonalization = createWidget(container);
      widgets.push(container.__debaansPersonalization);
    });

    return widgets;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      mountAll();
      bindFormValidation();
    });
  } else {
    mountAll();
    bindFormValidation();
  }

  window.DebaansPersonalization = {
    create: createWidget,
    mountAll: mountAll,
    bindFormValidation: bindFormValidation,
    addPersonalizationAddons: addPersonalizationAddons,
    isAddonVariant: isAddonVariant,
    getAddonConfig: getAddonConfig,
    populateSwatches: populateSwatches,
    PROPERTY_NAME: PROPERTY_NAME,
    PROPERTY_STYLE: PROPERTY_STYLE
  };
})(window);
